var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 29.5h70v1H-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4 59.4l-.8-.8L68.3 30 39.6 1.4l.8-.8L69.7 30z"
  })));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA3MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4PSIwcHgiIHk9IjBweCI+Cgk8cGF0aCBkPSJNLTEgMjkuNWg3MHYxSC0xeiIvPgoJPHBhdGggZD0iTTQwLjQgNTkuNGwtLjgtLjhMNjguMyAzMCAzOS42IDEuNGwuOC0uOEw2OS43IDMweiIvPgo8L3N2Zz4=";
export { SvgArrowRight as ReactComponent };